export enum ELanguage {
  RU = 'ru',
  // EN = 'en'
}

export const LanguageList = Object.values(ELanguage);
